const Unlayer = () => import('./pages/Unlayer.vue')

const htmlBuilderRoutes = [
  {
    path: 'unlayer/:templateId?/:dynamicId?/:dynamicIndex?/:dynamicDestinationType?',
    name: 'unlayer',
    component: Unlayer,
  },
  {
    path: 'plan/unlayer/:templatePlanId/:templateId?',
    name: 'plan-unlayer',
    component: Unlayer,
  },
]

export default htmlBuilderRoutes
